// extracted by mini-css-extract-plugin
export default {"base":"ZZunL","tabName":"u0W6n","tabCount":"iwkd2","selected":"MdLfw","greyscale":"KK_R3"};